<template>
  <section class="cards">
    <div class="main_title">
      <h1>{{data.title}}</h1>
      <img class="arrow" :src="ArrowDown" alt="Arrow">
    </div>
    <div class="cardsList">
      <div class="card" v-for="(item, index) in data.cards" :key="index">
        <div class="card__title">
          <div class="card__title--text">
            <h3>{{item.region}}</h3>
            <span>{{item.states}}</span>
          </div>
          <!-- <div class="card__title--circle" :class="`c${index}`">
            <img :src="arrCircles[index]" alt="">
          </div> -->
        </div>
        <div class="card__content" v-html="item.info"></div>
      </div>
    </div>
  </section>
</template>

<script setup>
import circle_one from '@/assets/img/circles/one.png'
import circle_two from '@/assets/img/circles/two.png'
import circle_three from '@/assets/img/circles/three.png'
import circle_four from '@/assets/img/circles/four.png'
import circle_five from '@/assets/img/circles/five.png'
import ArrowDown from '@/assets/img/arrow_down.svg'
const props = defineProps(['data'])
const arrCircles = [circle_one, circle_two, circle_three, circle_four, circle_five]
</script>

<style lang="scss" scoped>
  .cards{
    @apply main-container px-2 z-2
    md:px-3 ;
    .main_title{
      @apply flex flex-row justify-between items-start w-full h-52 md:h-auto mb-12 md:mb-16 lg:mb-32;
      h1{
        @apply text-4xl md:text-[40px] lg:text-[70px] text-ore_green_dark font-medium ml-5 md:ml-24 lg:ml-7;
      }
      .arrow {
        @apply mr-5 md:mr-[30px] lg:mr-0 self-end md:self-start md:-translate-y-[25px] lg:-translate-y-[14px]  ;
      }

    }
    .cardsList{
      @apply grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[5px] md:gap-2 lg:gap-6;
      .card {
        @apply  h-80 lg:h-96 bg-white rounded-3xl pr-5 pl-6 py-12 flex flex-col justify-between;
        &__title {
          @apply flex flex-row justify-between w-full;
          &--text{
            h3{
              @apply text-ore_green text-3xl font-medium  mb-5;
            }
            span {
              @apply text-ore_green text-xl font-medium block w-60 lg:w-full;
            }
          }
          &--circle{
            @apply flex-[1_0_auto] flex flex-row justify-end items-start pt-1;
            img{
              @apply object-contain;
            }

            &.c3, &.c4, &.c5{
              @apply pt-0;
            }
          }
        }
        &__content:deep(p){
            @apply text-ore_green text-2xl lg:text-3xl font-medium mt-5 lg:mt-8;
        }
      }
    }
  }
</style>
